export default {"src":"https://wp-static.smartkarma.com/_next/static/media/commodities.61f467b0.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};